import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import type {
  TextMarqueeCarmiProps,
  TextMarqueeDefinition,
  TextMarqueeProps,
} from '../TextMarquee.types';
import { props as viewerPropsMapper } from './TextMarquee.mapper';

const props = composeMapper<
  PreviewWrapperProps<TextMarqueeProps>,
  TextMarqueeDefinition,
  TextMarqueeCarmiProps & { svgString: string }
>()(
  viewerPropsMapper,
  {
    add: ['componentViewMode', 'compPreviewState'],
  },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const { componentViewMode, compPreviewState } = dependencies;

    const isPreviewAnimationActive =
      !!compPreviewState?.includes('previewAnimation');

    return {
      ...viewerProps,
      isInEditor: componentViewMode !== 'preview',
      isPreviewAnimationActive,
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
